import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { FieldArray } from 'formik';
import PropTypes from 'prop-types';

import getTypicalYield from '../../../utils/getTypicalYield';

const defaultCostToPlant = {
  en: {
    alfalfa: { ha: '1200', topos: '400' },
    barley: { ha: '1233', topos: '411' },
    'broad beans': { ha: '3982', topos: '1327.33' },
    corn: { ha: '2936', topos: '978.67' },
    peas: { ha: '2176', topos: '725.33' },
    potato: { ha: '2784', topos: '976' },
    quinoa: { ha: '1500', topos: '500' },
  },
  es: {
    alfalfa: { ha: '1200', topos: '400' },
    cebada: { ha: '1233', topos: '411' },
    habas: { ha: '3982', topos: '1327.33' },
    maiz: { ha: '2936', topos: '978.67' },
    arveja: { ha: '2176', topos: '725.33' },
    papa: { ha: '2784', topos: '976' },
    quinua: { ha: '1500', topos: '500' },
  },
  qu: {
    alfalfa: { ha: '1200', topos: '400' },
    cebada: { ha: '1233', topos: '411' },
    habas: { ha: '3982', topos: '1327.33' },
    sara: { ha: '2936', topos: '978.67' },
    alverjas: { ha: '2176', topos: '725.33' },
    papa: { ha: '2784', topos: '976' },
    kinuwa: { ha: '1500', topos: '500' },
  },
};

const defaultMarketPrices = {
  en: {
    alfalfa: '0.8',
    barley: '2',
    'broad beans': '4.5',
    corn: '6',
    peas: '3.5',
    potato: '1',
    quinoa: '2',
  },
  es: {
    alfalfa: '0.8',
    cebada: '2',
    habas: '4.5',
    maiz: '6',
    arveja: '3.5',
    papa: '1',
    quinua: '2',
  },
  qu: {
    alfalfa: '0.8',
    cebada: '2',
    habas: '4.5',
    sara: '6',
    alverjas: '3.5',
    papa: '1',
    kinuwa: '2',
  },
};

export default function CropSelection({
  actions,
  language,
  pageContent,
  toggleDisableNextStep,
  unit,
}) {
  const { values, errors } = actions;
  const [checked, toggleChecked] = useState(
    pageContent.map((crop) => {
      let previouslyChecked = false;
      values.crops.forEach((selectedCrop) => {
        if (selectedCrop.name === crop) {
          previouslyChecked = true;
        }
      });
      return previouslyChecked;
    })
  );

  useEffect(() => {
    toggleDisableNextStep(values.crops.length < 1);
  }, [values]);

  return (
    <View style={styles.container}>
      <FieldArray
        name="crops"
        render={(arrayHelpers) => (
          <View style={{ flex: 1 }}>
            {pageContent.map((crop, index) => (
              <View
                key={crop}
                style={{
                  justifyContent: 'space-between',
                  flex: 1,
                  flexDirection: 'row',
                }}
              >
                <View>
                  <Text>{crop[0].toUpperCase() + crop.slice(1)}</Text>
                </View>
                <View>
                  <Checkbox
                    status={
                      values.crops.find((obj) => obj.name === crop) !==
                      undefined
                        ? 'checked'
                        : 'unchecked'
                    }
                    disabled={
                      values.crops.length > 3 &&
                      !values.crops.find((obj) => obj.name === crop)
                    }
                    onPress={() => {
                      let newChecked = checked.slice();
                      newChecked[index] = !checked[index];
                      toggleChecked(newChecked);
                      if (!checked[index]) {
                        arrayHelpers.push({
                          name: crop,
                          marketPrice:
                            defaultMarketPrices[language][crop.toLowerCase()],
                          costToPlant:
                            defaultCostToPlant[language][crop.toLowerCase()][
                              unit
                            ],
                          bound: '100',
                          plantDistribution: '0',
                          typicalYield: getTypicalYield(crop, values, language),
                        });
                      } else {
                        const idx = values.crops.indexOf(
                          values.crops.find((obj) => obj.name === crop)
                        );
                        arrayHelpers.remove(idx);
                      }
                    }}
                    color="#555988"
                  />
                </View>
              </View>
            ))}
          </View>
        )}
      />
      {typeof errors.crops === 'string' ? (
        <Text style={styles.error}>{errors.crops}</Text>
      ) : null}
    </View>
  );
}

CropSelection.propTypes = {
  actions: PropTypes.shape({
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  pageContent: PropTypes.array,
  toggleDisableNextStep: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  error: {
    color: 'red',
  },
});
